import React from 'react';
import { ContainerDisplayVariant, DividerVariant } from 'component/page/detail/DetailPageModularize/detailPageModularize.types';
import { CardContainer } from 'component/page/detail/DetailPageModularize/ContentWrapper/CardContainer';
import AccordionContainer from 'component/page/detail/DetailPageModularize/ContentWrapper/AccordionContainer';
import { ContentWrapperProps } from 'component/page/detail/DetailPageModularize/ContentWrapper/ContentWrapper.types';
import { Container, Divider } from '@drone-js/core';

export const ContentWrapper: React.FC<ContentWrapperProps> = (props) => {
    const { display, children, dividerVariant, pt, pb } = props;
    const isBoth = display === ContainerDisplayVariant.Both;
    const isContainer = display === ContainerDisplayVariant.Container || isBoth;

    return (
        <>
            <Container pt={pt} pb={pb}>
                <CardContainer isCard={isContainer}>
                    <AccordionContainer {...props}>{children}</AccordionContainer>
                </CardContainer>
            </Container>
            {dividerVariant === DividerVariant.Line && <Divider my="4" />}
        </>
    );
};

ContentWrapper.displayName = 'ContentWrapper';
